import '@styles/components/appCiviStationconStru.less';

const NewTwo = () => {
  return (
    <div className={'app-display-desc'}>
      <div className={'padding-top'}>
        <div className={'content-title'}>
          <p className={'text'}>
            直播回放：赋能新基建，开启新未来
            <br />
            —方案设计评审云上会议
          </p>
        </div>
        <div className={'content-introduction'}>
          <p>
            5月25日，跨世纪在线举办了“赋能新基建，开启新未来—方案设计评审云上会议”，这是方案设计评审系统首次在直播间亮相，该系统是中国路桥与跨世纪团队携手，充分利用跨世纪三维设计技术优势，吸收中国路桥项目设计经验，共同打造的专注于交通基建领域基于BIM+GIS，结合信息技术于一体的二/三维方案设计评审系统。在本次直播中，跨世纪产品经理林睿琦为大家详细介绍了方案设计评审系统的研发背景、业务逻辑以及具体功能，并针对用户在直播中的提问，进行了详细解答。
          </p>
        </div>
      </div>
      <div>
        <div className={'csc-text'}>本次直播都讲了那些问题？</div>
        <div className={'introduce'}>
          <div className={'flex'}>
            <span className={'list-d'}>◆</span>
            <span className={'list-text'}>为什么研发方案设计评审系统？</span>
          </div>
          <div className={'flex'}>
            <span className={'list-d'}>◆</span>
            <span className={'list-text'}>它如何解决行业中痛点问题？</span>
          </div>
          <div className={'flex'}>
            <span className={'list-d'}>◆</span>
            <span className={'list-text'}>工程师怎样使用它展示汇报？</span>
          </div>
        </div>
        <div className={'introduce'}>
          错过本次直播不用担心，点击链接：
          <a href={'https://xlo.h5.xeknow.com/sl/v2bVW'}>https://xlo.h5.xeknow.com/sl/v2bVW</a>
          <br />
          即可进入“赋能新基建，开启新未来—方案设计评审云上会议”观看高清直播。
        </div>
        <div className={'csc-text'}>扬长补短提升工程效率</div>
        <div className={'introduce'}>
          方案设计评审系统由中国路桥和跨世纪软件联合打造，其突破二维设计向三维参数化建模的快速转换瓶颈，解决多源数据组织管理技术难题，依托地理信息环境，提供线性工程设计方案的可视化商务展示、定量分析、在线互动评审等创新能力。
        </div>
        <div className={'text-center margin-top'}>
          <img className={'csc'} src={require('@images/common/new_04.jpg').default} alt="" />
          <p className={'qldsimgj'}>行业痛点</p>
        </div>
        <div className={'text-center margin-top'}>
          <img className={'csc'} src={require('@images/common/new_05.jpg').default} alt="" />
          <p className={'qldsimgj'}>方案设计评审系统技术支撑</p>
        </div>
        <div className={'csc-text'}>方案设计评审系统具有多种系统特点：</div>
        <div className={'introduce'}>
          <div className={'flex'}>
            <span className={'list-d'}>◆</span>
            <span className={'list-text'}>支持多源数据发布及数据集成管理；</span>
          </div>
          <div className={'flex'}>
            <span className={'list-d'}>◆</span>
            <span className={'list-text'}>专家在线评审互动、场景共享；</span>
          </div>
          <div className={'flex'}>
            <span className={'list-d'}>◆</span>
            <span className={'list-text'}>与CSD平台数据联动、多专业协同；</span>
          </div>
          <div className={'flex'}>
            <span className={'list-d'}>◆</span>
            <span className={'list-text'}>定性、定量方案对比，空间分析；</span>
          </div>
          <div className={'flex'}>
            <span className={'list-d'}>◆</span>
            <span className={'list-text'}>方案表达符合设计习惯，标注形式自定义；</span>
          </div>
          <div className={'flex'}>
            <span className={'list-d'}>◆</span>
            <span className={'list-text'}>施工阶段需要模型的完整结构和编码信息</span>
          </div>
          <div className={'flex'}>
            <span className={'list-d'}>◆</span>
            <span className={'list-text'}>汇报形式多样、自定义临建库。</span>
          </div>
        </div>
        <div className={'text-center margin-top'}>
          <img className={'csc'} src={require('@images/common/new_06.jpg').default} alt="" />
          <p className={'qldsimgj'}>功能多样</p>
        </div>
      </div>
    </div>
  );
};

export default NewTwo;
